import React from 'react';

import IconCard from './ProductContentHousing/IconCardContent';
import ProductCard from './ProductContentHousing/ProductCardContent';
import TextCard from './ProductContentHousing/TextCardContent';
import CaseStudies from './ProductContentHousing/CaseStudiesContent';

import {
    TypeProductCardWithoutUnresolvableLinksResponse,
    TypeProductContentHousingWithoutUnresolvableLinksResponse,
} from '../../_generated';
import { TGeneralComponent } from '../../types/types';

export const ProductContentHousingWrapper: React.FC<{ component: TGeneralComponent }> = ({
    component,
}) => {
    const assertedComponent =
        component as TypeProductContentHousingWithoutUnresolvableLinksResponse;
    const { fields } = assertedComponent;
    const cardType = fields?.ourComponent?.[0]?.sys?.contentType?.sys?.id;

    switch (cardType) {
        case 'productCard': {
            const ourComponent =
                fields?.ourComponent as TypeProductCardWithoutUnresolvableLinksResponse[];
            const productCardType = ourComponent?.[0]?.fields?.type;

            switch (productCardType) {
                case 'Icon Card': {
                    return <IconCard id={component.componentId} component={assertedComponent} />;
                }
                case 'Product Card': {
                    return (
                        <ProductCard
                            id={component.componentId}
                            type={fields.type}
                            component={assertedComponent}
                        />
                    );
                }
                case 'Text Card': {
                    return <TextCard id={component.componentId} component={assertedComponent} />;
                }
                default: {
                    return null;
                }
            }
        }
        case 'caseStudy': {
            return <CaseStudies id={component.componentId} component={assertedComponent} />;
        }
        default:
            return null;
    }
};
